<ion-card *ngIf="currentUser && (currentUser.only_dinein || currentUser.only_visitor)">
  <ion-item-divider id="customer-register-only-dinein" mode="ios">
    <ion-label>
      {{
        "cart.cart-components.customer-register-only-dine-in.account-info"
          | translate
      }}
    </ion-label>
  </ion-item-divider>

  <ion-row style="width: 100%" *ngIf="currentUser && (currentUser.only_dinein || currentUser.only_visitor)">
    <ion-col size="12" class="ion-text-center ion-no-padding">
      <ion-list class="ion-no-margin ion-no-padding">
        <ion-radio-group
          [(ngModel)]="loginChoice"
          (ionChange)="onLoginChoiceChange($event)"
        >
          <ion-item lines="full">
            <ion-label style="margin: 0">{{
              "cart.cart-components.customer-register-only-dine-in.order-without-login"
                | translate
            }}</ion-label>
            <ion-radio slot="start" value="order-without-login"></ion-radio>
          </ion-item>

          <ion-item lines="full" *ngIf="!storeInfo?.only_visitors_app">
            <ion-label style="margin: 0">{{
              "cart.cart-components.customer-register-only-dine-in.magic-login"
                | translate
            }}</ion-label>
            <ion-radio slot="start" value="magic-login"></ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-list>
    </ion-col>
  </ion-row>
</ion-card>
